import { app, authentication } from "@microsoft/teams-js";

let token: string | null = null;

// Kein eigener iframe-Check: mobile Teams-Clients rendern Tabs frameless, dort ist
// window.self === window.top. app.initialize() erkennt diesen Host über window.nativeInterface
// und lehnt außerhalb von Teams von selbst ab ("No Parent window found").
export function reviewLimitSessionId(subPageId?: string): string | null {
  const match = subPageId?.match(/^review-limit:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i);
  return match?.[1] ?? null;
}

export async function initializeTeams(): Promise<{ theme: string; subPageId?: string }> {
  await app.initialize();
  const context = await app.getContext();
  app.notifySuccess();
  return { theme: context.app.theme ?? "default", subPageId: context.page.subPageId };
}

export async function authToken(force = false): Promise<string> {
  if (!token || force) token = await authentication.getAuthToken({ resources: [] });
  return token;
}

// Keeps the HTTP status, so callers can tell "deliberately not configured here" (503) from real failures.
export class ApiError extends Error {
  // body: the parsed error payload, e.g. partial results of an aborted run (HTTP 502).
  constructor(message: string, readonly status: number, readonly code?: string, readonly body?: unknown) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const run = async (force: boolean) => fetch(path, {
    ...init,
    headers: {
      Authorization: `Bearer ${await authToken(force)}`,
      ...(init.body ? { "Content-Type": "application/json" } : {}),
      ...init.headers,
    },
  });
  let response = await run(false);
  if (response.status === 401) response = await run(true);
  if (!response.ok) {
    const payload = await response.json<{ error?: string; code?: string }>().catch((): { error?: string; code?: string } => ({}));
    throw new ApiError(payload.error ?? `API ${response.status}`, response.status, typeof payload.code === "string" ? payload.code : undefined, payload);
  }
  return response.json<T>();
}
